import React, {
  ChangeEvent,
  useState,
  useEffect,
  InputHTMLAttributes,
  forwardRef,
  MouseEvent,
} from 'react';
import { filterNonNumerics } from '../../NumberField/filterNonNumerics';

export interface CleanNumberInputProps
  extends InputHTMLAttributes<HTMLInputElement> {
  value?: string;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
  inputRef?: React.Ref<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
  dataTestIdPrefix?: string;
  label?: string;
}

const CleanNumberInput = ({
  onChange,
  value = '',
  inputRef,
  dataTestIdPrefix,
  ...rest
}: CleanNumberInputProps): JSX.Element => {
  const [filteredValue, setFilteredValue] = useState(filterNonNumerics(value));
  useEffect(() => setFilteredValue(value), [value]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const filteredValue = filterNonNumerics(event.target.value);
    const filteredEvent = { ...event };
    filteredEvent.target.value = filteredValue;
    setFilteredValue(filteredValue);
    onChange?.(filteredEvent);
  };

  return (
    <input
      value={filteredValue}
      onChange={handleChange}
      type="tel"
      ref={inputRef}
      data-testid={dataTestIdPrefix}
      {...rest}
    />
  );
};

const CleanNumberInputWithRef = forwardRef(
  (props: CleanNumberInputProps, ref) => (
    <CleanNumberInput inputRef={ref} {...props} />
  )
);
export default CleanNumberInputWithRef;
